import * as request from '../api-request'

export const createAffiliateUser = (token) => {
  return request.toJSON('POST', 'affiliate/create_account', {})
}

export const createAffiliateCode = () => {
  return request.toJSON('POST', 'affiliate/create_code', {})
}

export const getAffiliateUser = () => {
  return request.toJSON('get', 'affiliate/get_account', {})
}

export const getCodeInfo = () => {
  return request.toJSON('get', 'affiliate/get_code_info', {})
}
